import React, { useEffect, useMemo } from "react";
import { ConsultationFormWidget } from "../../Components/ConsultationFormWidget";
import { useLocation } from "react-router-dom";
import { ChatAlt2Icon } from "@heroicons/react/outline";
import { useTranslation } from "react-i18next";
import {
  requestListConsultationByUser,
  requestListService,
  useAuthState,
  useConsultationDispatch,
  useConsultationState,
} from "../../Context";
import Badge from "../../Components/Badge";

const ConsultationFormGuest = () => {
  const { t } = useTranslation();

  const consultationDispatch = useConsultationDispatch();
  const { consultations, serviceLoading, services } = useConsultationState();

  const { user } = useAuthState();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const guestID = searchParams.get("id");
  const guestClient = searchParams.get("client");

  useEffect(() => {
    if (services.length === 0 && !serviceLoading) {
      requestListService(consultationDispatch);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (user.id) {
      requestListConsultationByUser(consultationDispatch, {
        userID: user.id,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id]);

  const firstOngoingConsultation = useMemo(() => {
    return consultations.find(
      (consultation) => consultation.status === "ONGOING",
    );
  }, [consultations]);

  return (
    <div>
      {firstOngoingConsultation && Boolean(user?.id) ? (
        <div className="bg-white border border-gray-200 rounded-md sm:rounded-lg shadow-sm sm:w-1/2 w-full mb-2">
          <a href={`/consultation/${firstOngoingConsultation.id}`}>
            <div className="px-4 py-6 sm:px-6">
              <div className="flex">
                <div className="flex flex-1 gap-4">
                  <div className="flex items-center">
                    <div className="p-2 bg-blue-100 border border-blue-300 rounded-lg">
                      <ChatAlt2Icon className="w-6 h-6 text-blue-600" />
                    </div>
                  </div>
                  <div className="flex items-start flex-col">
                    <p className="font-medium">
                      {firstOngoingConsultation?.category?.name}
                    </p>
                    <p className="text-sm">
                      {firstOngoingConsultation?.consultant?.user?.name}
                    </p>
                  </div>
                </div>
                <div className="flex flex-col items-end">
                  <Badge type="success" title={t("Ongoing")} />
                </div>
              </div>
            </div>
          </a>
        </div>
      ) : !Boolean(user?.id) ? (
        <div className="bg-white border border-gray-200 rounded-md sm:rounded-lg shadow-sm sm:w-1/2 w-full mb-2">
          <a href="/consultation?status=ALL">
            <div className="px-4 py-6 sm:px-6">
              <div className="flex">
                <div className="flex flex-1 gap-4">
                  <div className="flex items-center">
                    <div className="p-2 bg-gray-100 border border-gray-300 rounded-lg">
                      <ChatAlt2Icon className="w-6 h-6 text-gray-600" />
                    </div>
                  </div>
                  <div className="flex items-start flex-col">
                    <p className="font-medium">
                      {t("Access Your Consultations")}
                    </p>
                    <p className="text-sm">
                      {t("Sign in to view your consultations")}
                    </p>
                  </div>
                </div>
                <div className="flex flex-col items-end">
                  <span className="text-sm font-medium text-blue-600 hover:text-blue-500">
                    {t("Log in")}
                  </span>
                </div>
              </div>
            </div>
          </a>
        </div>
      ) : null}
      <div className="bg-white border border-gray-200 rounded-md sm:rounded-lg shadow-sm">
        <ConsultationFormWidget
          categories={services}
          loading={serviceLoading}
          withConsultantButton={false}
          withAddOns={false}
          guest
          guestID={guestID}
          guestClient={guestClient}
        />
      </div>
    </div>
  );
};

export default ConsultationFormGuest;
